export default __webpack_public_path__ + "static/media/scooter.fc32345c.svg";